import { useTranslation } from 'react-i18next';

import { updateTask } from 'actions/tasks';

import { useCanUser } from 'shared-hooks/permission';
import { useIsDependant } from 'shared-hooks/task';

import CanUser from 'components/CanUser';
import TaskCompleteToggle from 'components/TaskCompleteToggle';
import MultiLineInput from 'components/MultiLineInput';

const TaskTitle = ({ id, task, onToggleComplete }) => {
    const { t } = useTranslation('task');
    const canEdit = useCanUser('editTask', task.created_by);
    const [, dependantOn] = useIsDependant(id);

    const handleNameBlur = name => {
        updateTask(id, { name });
    }

    return (
        <div className="content-panel-title">
            <CanUser type="completeTask" customList={task.created_by}>
                <div className="content-panel-complete-shortcut">
                    <TaskCompleteToggle
                        id={id}
                        checkSubtasks={true}
                        dependantOn={dependantOn}
                        completed={task.completed}
                        projectId={task.project}
                        size="large"
                        onChange={onToggleComplete}
                    />
                </div>
            </CanUser>

            <MultiLineInput
                className="content-panel-field-input"
                placeholder={t('Add task name')}
                canEdit={canEdit}
                value={task.name}
                // provideController={this.setNameInputCtrl}
                onBlur={handleNameBlur}
            />
        </div>
    );
}

export default TaskTitle;
